// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"477":"8d3adf3f","578":"402fa7bf"}[chunkId] + ".chunk.css";
};